<!--
 * @Author: your name
 * @Date: 2022-02-15 14:55:43
 * @LastEditTime: 2022-02-15 15:14:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /xingmahui_front/src/views/contents/bjfamousdoctor/bjys.vue
-->
<template>
  <div>
    <keep-alive :include='includes' :max="5">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
  name: "bjDoctor",
  
 
  data() {
    return {};
  },
  computed: {
    ...mapState({
       includes: state => state.includes,
     }),
  },

};
</script>

<style lang='scss' scoped>
</style>
